import { useState } from 'react';
import { useQuery } from 'react-query';
import { getSpecializations } from 'src/services/specializations.service';
import { Button } from '@mui/material';
import { useTheme } from '@material-ui/core/styles';
import List from '@mui/material/List';
import { ListItem, ListItemButton, Stack } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import SpecializationDialog from './SpecializationDialog';
import { Icon } from '@iconify/react';
import medicineBoxFilled from '@iconify/icons-ant-design/medicine-box-filled';
import { CircularProgress } from '@material-ui/core';
const AdminSpecializations = () => {
  const theme = useTheme();
  const [isAdding, setIsAdding] = useState(false);
  const {
    isLoading,
    isError,
    data: specializations,
    error
  } = useQuery('specializations', getSpecializations);
  const [dialogState, setDialogState] = useState('create');
  const [selectedSpec, setSelectedSpec] = useState();
  return (
    <div>
      <SpecializationDialog
        open={isAdding}
        state={dialogState}
        spec={selectedSpec}
        onClose={() => {
          setIsAdding(false);
        }}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
        <Stack direction={'row'} alignItems="center" style={{}}>
          <Icon
            icon={medicineBoxFilled}
            style={{ marginRight: '0.5rem', color: theme.palette.grey[700] }}
            fontSize={20}
          />
          <h2>Specializations</h2>
        </Stack>
        <Button
          variant="contained"
          color="incorta"
          onClick={() => {
            setDialogState('create');
            setIsAdding(true);
          }}
          disabled={isLoading || isAdding}
        >
          Add
        </Button>
      </div>
      {isLoading ? (
        <CircularProgress color="incorta" />
      ) : isError ? (
        error.message
      ) : (
        <List
          component="div"
          style={{ width: '100%', overflowY: 'scroll', maxHeight: '15rem' }}
          aria-labelledby="nested-list-subheader"
        >
          {specializations.data.map((spec) => {
            return (
              <ListItem disablePadding key={spec.id}>
                <ListItemButton
                  onClick={() => {
                    setSelectedSpec(spec);
                    setDialogState('edit');
                    setIsAdding(true);
                  }}
                >
                  <ListItemText>{spec.specialization_description}</ListItemText>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      )}
    </div>
  );
};

export default AdminSpecializations;
